// A list of supported methodologies
export var MethodologyType;
(function (MethodologyType) {
    MethodologyType["GHG_ADMINISTRATION"] = "GHG_ADMINISTRATION";
    MethodologyType["BISKO"] = "BISKO";
    MethodologyType["GPC"] = "GPC";
})(MethodologyType || (MethodologyType = {}));
